<script setup>
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
</script>

<template>
  <div
    class="flex flex-col items-center justify-center h-full w-full gap-3 text-n-slate-11"
  >
    <fluent-icon icon="chat-multiple" size="40" class="text-n-slate-9" />
    <p class="text-sm font-medium">{{ t('AGENT_CHAT.EMPTY_STATE') }}</p>
  </div>
</template>
